import React, {ReactElement, useEffect, useState} from 'react';
import RupeesIcon from '../../../assets/images/rupees.svg';
import {promoResponse} from '../../../redux/checkoutSlice';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import npQRCode from '../../../assets/images/np_qr-code.svg';
import OrderCard from './OrderCard';
import QRCode from 'react-qr-code';
import {OrderResponse} from '../../../lib/order-types';
import {
  getAccessToken,
  getMetadata,
  getStoreInformation,
  setOrderID,
  setOrderResp,
} from '../../../core/localstorage-data';
import {
  checkTransactionStatus,
  generateInvoice,
  invoiceGeneratedError,
  invoiceGeneratedLoading,
  invoiceGeneratedResponse,
  paymentStatus,
  paymentStatusError,
  paymentStatusLoading,
  requestTxnToken,
  resetInvoiceResponse,
  resetPaymentStatus,
  resetTransactionResponse,
  resetTxnToken,
  transactionStatusError,
  transactionStatusResponse,
  transactionStatusResponseLoading,
  txnToken,
  verifyPaymentStatus,
} from '../../../redux/orderSlice';
import cogoToast from 'cogo-toast';
import ErrorToast from '../../../components/notifications/ErrorToast';
import {useHistory, useLocation} from 'react-router-dom';
import {setActivityRunning, setPaymentMode} from '../../../redux/globalSlice';
import {PAYTM_MID_META_KEY} from '../../../lib/constants';
import {onPayNowMoengageEvent} from '../../../lib/moengageCall';
import InformationToast from '../../../components/notifications/InformationToast';

type PriceDetails = {
  totalMRP: number;
  additionalDiscount: number;
  totalAmount: number;
};
type OrderSummaryProps = {
  type?: string;
  orderResp?: OrderResponse;
};
const OrderSummary: React.FC<OrderSummaryProps> = ({
  type,
  orderResp,
}: OrderSummaryProps): ReactElement => {
  const accessToken = getAccessToken();
  const storeCode = `0${getStoreInformation().store_code}`;
  const dispatch = useAppDispatch();
  const verifyPaymentResp = useAppSelector(paymentStatus);
  const paymentStatusLoaded = useAppSelector(paymentStatusLoading);
  const errorInPaymentStatus = useAppSelector(paymentStatusError);
  const [verifyStatus, setVerifyPaymentStatus] = useState(false);
  const transactionStatusResp = useAppSelector(transactionStatusResponse);
  const transactionStatusLoading = useAppSelector(
    transactionStatusResponseLoading,
  );
  const transactionStatusRespError = useAppSelector(transactionStatusError);
  const invoiceResponse = useAppSelector(invoiceGeneratedResponse);
  const invoiGenerationError = useAppSelector(invoiceGeneratedError);
  const invoiceLoading = useAppSelector(invoiceGeneratedLoading);
  const txn_Token = useAppSelector(txnToken);
  let invoiceStatus = true;
  const navigate = useHistory();
  const [paymentEnabled, setPaymentEnabled] = useState<boolean>(false);
  const metaData = getMetadata();
  const paytmURL = metaData.find(
    (obj: {name: string}) => obj.name === PAYTM_MID_META_KEY,
  );
  const [payemntTimer,setPaymentTimer] = useState(-1);
  const [secondCounter,setSecondCounter] = useState(0);
  const pagelocation = useLocation();
  const paymentInitiatedAt = orderResp?.paymentInitiatedAt;
  const serverTime = new Date(paymentInitiatedAt).getTime()+155000;
  const paymentInitiatedRange = Math.floor((new Date().getTime() - serverTime) / 60000);
  const paymentInitiatedRangeSeconds = Math.floor((new Date().getTime() - serverTime)/1000)%60;
  useEffect(() => {
    if(paymentInitiatedRange<=5){
      setPaymentTimer(4-paymentInitiatedRange);
      setSecondCounter(60-paymentInitiatedRangeSeconds);
    }
    return () => {
      dispatch(resetTxnToken());
    };
  }, []);

  useEffect(()=>{
    let secondTimer: any;
    if(payemntTimer>=0&&payemntTimer<=5){
      if(paymentInitiatedRangeSeconds===0){
        setSecondCounter(59);
      }
    
    secondTimer = setInterval(() => {
      setSecondCounter((secondCounter) => (secondCounter===0?0: secondCounter - 1));
    }, 1000);
  }else{
    clearInterval(secondTimer);
  }
  return () => clearInterval(secondTimer);
  },[payemntTimer])

  useEffect(()=>{
    let timerId :any;
    if (paymentInitiatedRange<=5&& payemntTimer>=0 &&paymentInitiatedRangeSeconds!=0) {
      timerId = setInterval(() => {
        setPaymentTimer((payemntTimer) => payemntTimer - 1);
      }, 60000-(paymentInitiatedRangeSeconds*1000));
    }else if(paymentInitiatedRange<=5&& payemntTimer>=0 &&paymentInitiatedRangeSeconds===0){
      timerId = setInterval(() => {
        setPaymentTimer((payemntTimer) => payemntTimer - 1);
      }, 1000*60);
    }
     else {
      clearInterval(timerId);
    }

    return () =>{ clearInterval(timerId);
    }
  },[payemntTimer])

  function loadCheckoutScript(
    paytmURL: string,
    callback?: (success: boolean) => void,
  ) {
    if (window && window.Paytm && window.Paytm.CheckoutJS) {
      console.log('paytm already exists. skipping the scirpt load.');
      return;
    }

    if (!paytmURL) {
      console.log('did not load paytm preload script... payment is failing..');
      return;
    }

    const scriptElement = document.createElement('script');
    scriptElement.async = true;
    scriptElement.src = (paytmURL as any).value;
    scriptElement.type = 'application/javascript';
    scriptElement.onload = () => {
      console.log('paytm script loaded...');
      if (callback) callback(true);
    };

    scriptElement.onerror = error => {
      console.error('paytm script load failed...', error);
      if (callback) callback(false);
    };

    document.body.appendChild(scriptElement);
  }

  useEffect(() => {
    // const statussss = getLmrChecked();
    // const data = statussss === null ? lmrChecked : statussss;
    // dispatch(setLmrChecked(data));

    // const tier = getUser().tier;
    // // lmrChecked = false;
    // const pointsAvailable = getUser().pointsAvailable;

    // if ((tier === 'ELITE' || tier === 'EDGE') && pointsAvailable === 0) {
    //   setShowLmrpoint(true);
    // }
    loadCheckoutScript(paytmURL, setPaymentEnabled);

    if (window && window.Paytm && window.Paytm.CheckoutJS) {
      setPaymentEnabled(true);
    }

    //setPageName(pageName.paymentPage);

    // const parameters = {
    //   accessToken: accessToken,
    //   payload: {
    //     storeCode: storeCode,
    //     cardNumber: card_number,
    //     storeKeyId: storeId,
    //   },
    // };
    // dispatch(fetchOrder(parameters));
    // dispatch(resetTxnToken());
  }, []);

  useEffect(() => {
    if (transactionStatusResp) {
      if (transactionStatusResp.statusCode === '200') {
        //redirect to confirm page
        invoiceStatus = false;
        navigate.push('/checkout/confirm');
      } else {
        invoiceStatus = false;
        navigate.push('/checkout/confirm');
      }
    }
    if (
      transactionStatusLoading === false &&
      transactionStatusRespError != ''
    ) {
      invoiceStatus = false;
      navigate.push('/checkout/confirm');
    }
  }, [
    transactionStatusResp,
    transactionStatusLoading,
    transactionStatusRespError,
  ]);

  useEffect(() => {
    if (invoiceResponse !== null) {
      if (invoiceResponse.txnStatus === 'completed') {
        invoiceStatus = false;
        navigate.push('/checkout/confirm');
      } else {
        if (invoiceResponse.statusCode === '1053') {
          invoiceStatus = false;
          navigate.push('/checkout/confirm');
        }

        if (
          invoiceResponse.statusCode === '1054' ||
          invoiceResponse.statusCode === '1055' ||
          invoiceResponse.statusCode === '1056' ||
          invoiceResponse.statusCode === '1057'
        ) {
          //navigate.push('/checkout/payment_error');
          cogoToast.error(
            <ErrorToast title="Error" description="Payment Not processed" />,
            {
              hideAfter: 2,
              renderIcon: () => {
                return null;
              },
            },
          );
        } else {
          const orderId = orderResp?.orderId;
          if (orderId != undefined) {
            const parameters = {
              accessToken,
              payload: {
                storeCode: storeCode,
                orderId: orderId,
              },
            };
            dispatch(checkTransactionStatus(parameters));
          }
        }
      }
    }
    if (invoiGenerationError !== null) {
      if (invoiGenerationError.message != '' && invoiceLoading === false) {
        if (invoiGenerationError.error === 'lmrPointsRedumption') {
          cogoToast.error(
            <ErrorToast title="Error" description="Payment Not processed" />,
            {
              hideAfter: 2,
              renderIcon: () => {
                return null;
              },
            },
          );
        } else {
          invoiceStatus = false;
          navigate.push('/checkout/confirm');
        }
      }
    }
  }, [invoiceResponse, invoiGenerationError, invoiceLoading]);

  useEffect(() => {
    const orderId = orderResp?.orderId;
    if (verifyPaymentResp !== null && paymentStatusLoaded === false) {
      if (
        verifyPaymentResp !== null &&
        verifyPaymentResp.resultStatus === 'TXN_SUCCESS'
      ) {
        if (orderId != undefined) {
          const parameters = {
            accessToken,
            payload: {
              storeCode,
              orderId: orderId,
              redeemLMR: false,
            },
          };
          dispatch(generateInvoice(parameters));
        }
      } else if (
        verifyPaymentResp !== null &&
        verifyPaymentResp.resultStatus === 'TXN_FAILURE' &&
        verifyStatus === true
      ) {
        dispatch(resetInvoiceResponse());
        dispatch(resetTransactionResponse());
        navigate.push('/checkout/payment_error', {
          orderSummary: true,
        });
        cogoToast.error(
          <ErrorToast title="Error" description="Payment Not processed" />,
          {
            hideAfter: 2,
            renderIcon: () => {
              return null;
            },
          },
        );
      } else if (
        verifyPaymentResp !== null &&
        verifyPaymentResp.resultStatus != 'TXN_FAILURE' &&
        verifyPaymentResp.resultStatus != 'TXN_SUCCESS'
      ) {
        dispatch(resetInvoiceResponse());
        dispatch(resetTransactionResponse());
        navigate.push('/checkout/payment_error', {
          orderSummary: true,
        });
        cogoToast.error(
          <ErrorToast title="Error" description="Payment Not processed" />,
          {
            hideAfter: 2,
            renderIcon: () => {
              return null;
            },
          },
        );
      }
    }
    if (
      errorInPaymentStatus != '' &&
      verifyStatus === true &&
      paymentStatusLoaded === false
    ) {
      cogoToast.error(
        <ErrorToast title="Error" description="Payment Not processed" />,
        {
          hideAfter: 2,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
    dispatch(resetPaymentStatus());
  }, [verifyPaymentResp, errorInPaymentStatus, paymentStatusLoaded]);

  useEffect(() => {
    if (txn_Token && txn_Token.status === 'S') {
      //directed to redeem lmr api response
      // if (priceDetails?.totalAmount === 0) {
      //   const orderId = orderResp && orderResp.orderId;
      //   //Call generate invoice api here
      //   const parameters = {
      //     accessToken,
      //     payload: {
      //       storeCode,
      //       orderId: orderId,
      //       redeemLMR: lmrChecked ? true : false,
      //     },
      //   };
      //   dispatch(generateInvoice(parameters));
      // } else {
      const config = {
        root: '',
        flow: 'DEFAULT',
        merchant: {
          logo: 'https://buddy.maxfashion.in/assets/common/max_logo.png',
          name: ' ',
        },
        style: {
          headerBackgroundColor: '#8dd8ff',
          headerColor: '#3f3f40',
          bodyColor: '#303AB2',
        },
        data: {
          orderId: txn_Token.paymentOrderId,
          token: txn_Token.txnToken,
          tokenType: 'TXN_TOKEN',
        },
        handler: {
          notifyMerchant: function (eventName: string, data: any) {
            if (eventName == 'SESSION_EXPIRED') {
              alert('Your session has expired!!');
              location.reload();
            }
          },
        },
      };
      if (window.Paytm && window.Paytm.CheckoutJS) {
        dispatch(setActivityRunning(true));
        // initialze configuration using init method
        window.Paytm.CheckoutJS.init(config)
          .then(function onSuccess() {
            dispatch(setActivityRunning(false));
            // after successfully update configuration invoke checkoutjs
            window.Paytm.CheckoutJS.invoke();
          })
          .catch(function onError(error: any) {
            dispatch(setActivityRunning(false));
            cogoToast.error(
              <ErrorToast
                title="Error"
                description={
                  error.message || 'Something went wrong! please try again'
                }
              />,
              {
                hideAfter: 3,
                renderIcon: () => {
                  return null;
                },
              },
            );
            console.log('Error => ', error);
          });
      }
      //}
    }
    if (txn_Token && txn_Token.status === 'F') {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Something went wrong! please try again"
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  }, [txn_Token]);

  const StatusHandler = () => {
    setVerifyPaymentStatus(true);
    if (orderResp) {
      setOrderResp(orderResp);
    }
    console.log('Order Response', orderResp?.orderId);
    const orderId = orderResp?.orderId;
    const paymentInitiatedAt = orderResp?.paymentInitiatedAt;
    const paymentInitiatedRange = Math.floor((new Date().getTime() - new Date(paymentInitiatedAt).getTime()) / 60000);

    if (storeCode === orderResp?.storeCode) {
      if (paymentInitiatedRange >= 5) {
        if (accessToken != null && orderId != undefined) {
          const parameters = {
            accessToken,
            payload: {
              checksum: 'order-history-check-status',
              storeCode,
              orderId,
              verifyPaymentRetryCount: -1,
            },
          };
          dispatch(verifyPaymentStatus(parameters));
        }
      } else {
        cogoToast.error(
          <InformationToast
            title="Information"
            description={'Please check after 5 minutes.'}
          />,
          {
            hideAfter: 3,
            renderIcon: () => {
              return null;
            },
          },
        );
      }
    } else {
      cogoToast.error(
        <InformationToast
          title="Information"
          description={'The current store is not the same as the one where the order was placed.'}
        />,
        {
          hideAfter: 3,
          renderIcon: () => {
            return null;
          },
        },
      );
    }
  };

  const RepayHandler = () => {
    if (orderResp) {
      setOrderResp(orderResp);
    }
    //if payment zero then call generate invoice api
    const paymentMode = 'js checkout';
    dispatch(setPaymentMode(paymentMode));

    // if (orderResp && orderResp.hasPaid === true) {
    //   const orderId = orderResp && orderResp.orderId;
    //   //Call generate invoice api here
    //   const parameters = {
    //     accessToken,
    //     payload: {
    //       storeCode,
    //       orderId: orderId,
    //       redeemLMR: false,
    //     },
    //   };
    //   dispatch(generateInvoice(parameters));
    // } else {
    if (!paymentEnabled) {
      console.error('Payment script is not loaded...');
      return;
    }

    // if (lmrChecked) {
    //   if (orderResp && orderResp.orderId) {
    //     const parameters = {
    //       accessToken: getAccessToken(),
    //       payload: {
    //         orderId: orderResp.orderId,
    //         storeCode,
    //       },
    //     };
    //     dispatch(lmrRedeemData(parameters));
    //     onPayNowMoengageEvent(orderResp);
    //   } else {
    //     console.warn('Order id is missing...');
    //   }
    // } else {
    if (orderResp && orderResp.orderId) {
      const parameters = {
        accessToken: getAccessToken(),
        payload: {
          orderId: orderResp.orderId,
          storeCode,
          redeemLMR: true,
          isRepay: true,
        },
      };
      dispatch(requestTxnToken(parameters));

      onPayNowMoengageEvent(orderResp);
    }
    //}
    //}
  };

  return (
    <div className="px-4 pb-4 h-full overflow-y-auto">
      <div>Order ID #{orderResp?.orderId}</div>
      {type === 'detagging' && (
        <div className="confirm-qrcode relative bg-white border-1 mx-auto mt-4 border-gray-300 border-solid h-36 rounded-full w-36">
          {/* <img
            className="m-auto absolute left-inset20 top-inset20"
            src={npQRCode}
          /> */}
          <div className="m-auto absolute left-inset20 top-inset20">
            {orderResp && <QRCode value={orderResp.orderId} size={90} />}
          </div>
        </div>
      )}
      <div className={`${type === 'detagging' ? 'mt-8' : ''}`}>
        {orderResp && <OrderCard type="product" orderResp={orderResp} />}
        {orderResp && <OrderCard type="price" orderResp={orderResp} />}
      </div>
      {orderResp?.paymentInitiated &&
        orderResp.isCompleted === false &&
        pagelocation.pathname !== '/checkout/confirm' && !orderResp.hasExpired&&payemntTimer!=-1&&<div><div>Check Payment Status button will be enabled in</div><div className='font-bold'>{payemntTimer>9?payemntTimer:"0"+payemntTimer}:{secondCounter>9?secondCounter:"0"+secondCounter} </div><div> {payemntTimer<=1?"minute":"minutes"}</div></div>}
      {orderResp?.paymentInitiated &&
        orderResp.isCompleted === false &&
        pagelocation.pathname !== '/checkout/confirm' && !orderResp.hasExpired && (
          <div className="mb-24">
            <button
              className="w-full mt-20 cursor-none-allowed text-white  rounded-radius10  grid place-items-center focus:outline-none mx-auto p-3 text-center primary normal mb-2"
              onClick={StatusHandler}
              disabled={payemntTimer!=-1}>
              Check Payment Status
            </button>
            {/* <button
              className=" w-full cursor-none-allowed text-white  rounded-radius10  grid place-items-center focus:outline-none mx-auto p-3 text-center primary normal mb-2"
              onClick={RepayHandler}
              disabled={true}>
              Repay
            </button> */}
          </div>
        )}
    </div>
  );
};
export default OrderSummary;
